var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareScreenOff(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#ECECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1016 15.6016C13.4227 15.2804 13.8583 15.1 14.3125 15.1H33.6875C34.1417 15.1 34.5773 15.2804 34.8984 15.6016C35.2196 15.9227 35.4 16.3583 35.4 16.8125V31.1875C35.4 31.4124 35.3557 31.6351 35.2696 31.8428C35.1836 32.0506 35.0574 32.2394 34.8984 32.3984C34.7394 32.5574 34.5506 32.6836 34.3428 32.7696C34.1351 32.8557 33.9124 32.9 33.6875 32.9H14.3125C14.0876 32.9 13.8649 32.8557 13.6572 32.7696C13.4494 32.6836 13.2606 32.5574 13.1016 32.3984C12.9426 32.2394 12.8164 32.0506 12.7304 31.8428C12.6443 31.6351 12.6 31.4124 12.6 31.1875V16.8125C12.6 16.3583 12.7804 15.9227 13.1016 15.6016Z",
    stroke: "#212121",
    strokeWidth: 2.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.496 23.0894L23.2961 18.2933C23.6866 17.9028 24.3198 17.9028 24.7103 18.2933L29.5065 23.0894C29.897 23.4799 29.897 24.1131 29.5065 24.5036C29.1159 24.8941 28.4828 24.8941 28.0922 24.5036L25.0032 21.4146L25.0032 29C25.0032 29.5523 24.5555 30 24.0032 30C23.4509 30 23.0032 29.5523 23.0032 29L23.0032 21.4146L19.9102 24.5036C19.5197 24.8941 18.8865 24.8941 18.496 24.5036C18.1055 24.1131 18.1055 23.4799 18.496 23.0894Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareScreenOff);
export default __webpack_public_path__ + "static/media/share-screen-off.6ab525bd15dfd1094ae360ba03a331d6.svg";
export { ForwardRef as ReactComponent };